export default [
  {
    "pattern": {}
  },
  {
    "pattern": {}
  }
]